import { collectionMethods } from './collectionMethods.js';

const BASE_PATH = '/companies';

/**
 * Companies — the legal entities everything else in Administration names.
 *
 * The only noun that holds no relationship of its own. Every other collection
 * points AT a Company; a Company points at nothing, which is why this file
 * carries none of the `set…Company`, policy or knockout methods the other four
 * write out.
 */
export function companyMethods({ sendRequest, buildUrl }) {
    return {
        ...collectionMethods({ basePath: BASE_PATH, sendRequest, buildUrl }),

        /**
         * Every document naming this Company, and the roles it is named in.
         *
         * What a screen shows before it retires one: a Company that is still
         * somebody's payer cannot be retired, and this is how a caller finds out
         * before the refusal rather than after it.
         *
         * @returns {Promise<{ referencing: Array<{ collectionName: string, _id: string, name: string, roles: string[] }> }>}
         */
        async referencing(id) {
            return await sendRequest(
                buildUrl(`${BASE_PATH}/${encodeURIComponent(id)}/referencing`),
                'GET'
            );
        }
    };
}

export default companyMethods;
